import { render, staticRenderFns } from "./TabHistorico.vue?vue&type=template&id=78b79868&"
import script from "./TabHistorico.vue?vue&type=script&lang=js&"
export * from "./TabHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports